<template>
  <v-container>
    <v-layout row align-center class="my-3">
      <v-icon color="primary">description</v-icon>&nbsp;&nbsp;<span class="txt-titulo">Imprimir un Borrador de su Declaración</span>
    </v-layout>
      <v-card-actions class='justify-center'>
        <p>
          El presente formulario sólo sirve para la revisión de datos y
          <br>NO CONSTITUYE EL FORMULARIO OFICIAL 
        </p>
      </v-card-actions>
      <v-card-actions class='justify-center'>
        <v-btn
          :disabled="dialog"
          color="primary"
          @click='verificaHabilitacion( )'
        >
        <v-icon color='white'>picture_as_pdf</v-icon>&nbsp;Ver Reporte Borrador
        </v-btn>
      <v-dialog
        v-model="dialog"
        hide-overlay
        persistent
        scrollable
        max-width="240"       
      >
        <v-card
          color="white"
        >
          <v-card-text>
            <v-layout justify-center>
              <v-progress-circular
                indeterminate
                color="secondary"
                class="mb-0"
              ></v-progress-circular>
            </v-layout>
            <v-layout justify-center class="mt-2">
              <span class="caption">Por favor espere...</span>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>      
      </v-card-actions>    
      <v-card-actions class='justify-center'>
        <p v-if="tipo_usuario === 'usuario_externo' && dialog === false"><a @click='verificaHabilitacion( )'>
          (Opcional) Haga clic aquí o en el botón para ver el reporte Borrador  del formulario de
          <br>Declaración Jurada de Bienes y Rentas.
        </a>          
        </p>
        <p v-if="tipo_usuario !== 'usuario_externo' && dialog === false"><a @click='verificaHabilitacion( )'>
          (Opcional) Haga clic aquí o en el botón para ver el reporte Borrador  del formulario de
          <br>Declaración Jurada de Bienes y Rentas Digital.
        </a>          
        </p>
      </v-card-actions>      
    <v-layout align-center wrap v-if="tipo_usuario !== 'usuario_externo'">
      <v-flex md8 />
      <v-flex xs3 offset-xs9 align-end>
        <v-btn color="secondary" @click="$router.push('/parentesco')"><v-icon right dark>arrow_back_ios</v-icon>&nbsp;Anterior</v-btn>
        <v-btn color="accent" @click="$router.push('/transaccion')">Siguiente&nbsp;<v-icon right dark>arrow_forward_ios</v-icon></v-btn>
      </v-flex>
    </v-layout>
    <v-layout align-center wrap v-if="tipo_usuario === 'usuario_externo'">
      <v-flex md8 />
      <v-flex xs3 offset-xs9 align-end>
        <v-btn color="secondary" @click="$router.push('/apoderado')"><v-icon right dark>arrow_back_ios</v-icon>&nbsp;Anterior</v-btn>
        <v-btn color="accent" @click="$router.push('/transaccion')">Siguiente&nbsp;<v-icon right dark>arrow_forward_ios</v-icon></v-btn>
      </v-flex>
    </v-layout>
    <v-layout>
        <v-dialog v-model='dialogHabilitar' scrollable persistent max-width='95%'>
          <v-card>
            <v-toolbar dark color="primary" right>
                <v-toolbar-title><h4>Reporte Borrador</h4></v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="dialogHabilitar = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <global-file-visor v-if="this.dataPdfBase64" :base64="dataPdfBase64" mime='application/pdf' nombreArchivo='borrador.pdf'></global-file-visor>            
          </v-card>
        </v-dialog>
  </v-layout>
  </v-container>
</template>
<script>
import GlobalFileVisor from '@/common/util/GlobalFileVisor';
import Parametricas from '../djbrd/mixins/parametricas';
export default {
  mixins: [ Parametricas ],
  created () {
    // this.navBarEmmit();
    let token = this.$util.parseJwt(this.$storage.get('token'));
    this.tipo_usuario = token.tipo;
    this.obtenerEstadoDeclaracion().then(respuesta => {
      if (respuesta.finalizado) {
        if (respuesta.data.cod_estado === 3) {
          this.$message['warning']('Debe iniciar una nueva Declaración.');
          this.$router.push('/');
        }
        if (respuesta.data.cod_estado === 2) {
          this.$message['warning']('Su ultima Declaración no fue recepcionada, habilite la misma para terminarla');
          this.$router.push('/');
        }
        if (respuesta.data.cod_estado === -1) {
          this.$message['warning']('Debe iniciar una nueva Declaración.');
          this.$router.push('/');
        }
      }
    });
    this.$service.get('djbr_registro/valida_declaracion', {}).then(response => {
      if (response[0] && response[0].err_existente !== 0) {
        this.$message['warning'](response[0].err_mensaje + ' ' + 'volver a Datos Generales');
        this.$router.push('datos-generales');
      }
    });
  },
  components: {
    GlobalFileVisor
  },
  data: () => ({
    dialog: false,
    dialogHabilitar: false,
    dataPdfBase64: null,
    number: 0,
    tipo_usuario: '',
    url: `${process.env.API_URL}djbr_registro/borrador_declaracion`,
    deleteMode: false
  }),
  methods: {
    obtenerDatos () {
      let ua = navigator.userAgent;
      var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      var match = window.navigator.userAgent.match(/Firefox\/([0-9]+)\./);
      if (M[1] === 'Firefox') {
        var ver = match ? parseInt(match[1]) : 0;
        if (ver < 80) {
          this.$message['warning']('Tome en cuenta que para visualizar de manera correcta el documento su navegador debe estar actualizado.');
        }
      }
      this.$service
        .get(`djbr_registro/borrador_declaracion`, {})
        .then(response => {
          if (response) {
            if (response.err_existente === 0) {
              this.dialogHabilitar = true;
              this.dialog = false;
              this.dataPdfBase64 = response.base64;
              this.deleteMode = true;
            } else {
              this.deleteMode = false;
            }
          } else {
            this.dialog = false;
          }
        }).catch(e => {
          this.dialog = false;
        });
    },
    verificaHabilitacion  () {
      this.dialog = true;
      this.obtenerDatos();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/declaracion/borrador.vue